export default __webpack_public_path__ + "locales/sk/InviteDialog.json?hash=399b4b32520dca54d1540f8e89acbb20";